var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFollowUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.07473 39C7.94707 39 7.81828 38.9753 7.69563 38.9245C7.32526 38.7711 7.08374 38.4097 7.08374 38.0088V22.2323C7.08374 19.3265 9.44779 16.9625 12.3536 16.9625H27.684C30.5898 16.9625 32.9538 19.3265 32.9538 22.2323V29.7489C32.9538 32.6547 30.5898 35.0187 27.684 35.0187H12.4668L8.77577 38.7096C8.58619 38.8993 8.33264 39 8.07473 39Z",
    fill: "#083E3E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.6464 9H20.316C17.4102 9 15.0461 11.364 15.0461 14.2698V21.7863C15.0461 24.6922 17.4102 27.0562 20.316 27.0562H35.5332L39.2241 30.7471C39.4137 30.9367 39.6672 31.0375 39.9251 31.0374C40.0529 31.0374 40.1817 31.0128 40.3042 30.962C40.6746 30.8085 40.9161 30.4472 40.9161 30.0463V14.2698C40.9162 11.364 38.5522 9 35.6464 9Z",
    fill: "#179D82"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0094 18.9448C22.5278 18.9448 23.0245 18.4889 23.0005 17.9536C22.9765 17.4166 22.565 16.9624 22.0094 16.9624C21.4909 16.9624 20.9942 17.4183 21.0182 17.9536C21.0422 18.4906 21.4537 18.9448 22.0094 18.9448Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M27.9813 18.9449C28.4997 18.9449 28.9965 18.489 28.9725 17.9537C28.9484 17.4167 28.5369 16.9625 27.9813 16.9625C27.4628 16.9625 26.9661 17.4184 26.9901 17.9537C27.0141 18.4907 27.4256 18.9449 27.9813 18.9449Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M33.9537 18.9448C34.4722 18.9448 34.9689 18.4889 34.9449 17.9536C34.9208 17.4166 34.5094 16.9624 33.9537 16.9624C33.4352 16.9624 32.9385 17.4183 32.9625 17.9536C32.9866 18.4906 33.398 18.9448 33.9537 18.9448Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M28.9726 17.9537C28.9486 17.4167 28.5371 16.9625 27.9814 16.9625V18.9449C28.4999 18.9449 28.9966 18.489 28.9726 17.9537Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFollowUp);
export default __webpack_public_path__ + "static/media/followUp.c8728a96c58b0466188af6b5d855761b.svg";
export { ForwardRef as ReactComponent };